import { loader } from 'graphql.macro';

import { updateProfileInCache as updateMeInCache } from '@loyalup/core';

const ME_QUERY = loader('../gql/queries/Me.gql');

const updateProfileInCache = (cache, update) => {
  updateMeInCache({ cache, update, query: ME_QUERY });
};

export default updateProfileInCache;
